import { BaseWebComponent } from '../components/BaseWebComponent.js'
import { HomeLinks, ModalConfig, Source, UserInfo } from '../utils/types.js'
import { queryElement } from '../utils/utils.js'

const template = `
<style>
  button {
    all: unset;
    outline: none;
    background: transparent;
    border: 1px solid transparent;
  }

  .cqmt-home-menu {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 25rem;
  }
  .cqmt-row {
    display: flex;
    gap: 6px;
  }
  .cqmt-rounded-container {
    border-radius: 6px;
    background-color: var(--bunker-1000);
    padding: 1rem;
  }
  .cqmt-centered-info {
    display: flex;
    flex-grow: 1;
    justify-content: center;
  }
  .button-hover {
    cursor: pointer;
  }
  .cqmt-icon-spacing {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-right: 0.5rem;
  }
  .cqmt-info-header-text {
    color: white;
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 1rem;
    line-height: 1.375rem;
    letter-spacing: 1.5%;
  }
  .cqmt-welcome-text {
    margin-top: 1px;
    color: white;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1rem;
    letter-spacing: 1px;
  }
  .cqmt-user-text {
    font-weight: 700;
    letter-spacing: 2px;
  }
  .cqmt-info-text {
    padding-top: 0.5rem;

    color: white;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.1%;
  }
  .cqmt-subscription-info {
    margin-top: 16px;
    border: 1px solid var(--bunker-50);
    border-radius: 6px;
    width: 100%;
  }
  .cqmt-subscription-header {
    border-bottom: 1px solid var(--bunker-50);
    padding: 8px 12px;
  }
  .cqmt-header-text {
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 2px;
    padding-bottom: 8px;
  }
  .cqmt-subscription-indentation {
    padding-left: 16px;
  }
  .cqmt-bold-text {
    font-family: 'Inter', sans-serif;
    font-weight: 600;
    font-size: 0.875rem;
    line-height: 1.25rem;
    letter-spacing: 0.1%;
  }
  .cqmt-subscription-body {
    border-bottom: 1px solid var(--bunker-50);
    padding: 10px;
  }
  .cqmt-subscription-footer {
    padding: 10px 10px 2px;
  }

  a {
    text-decoration: none;
  }

  ul {
    margin: 0 0 6px;
    padding: 0;
    list-style-type: none;

    li {
      margin: 6px 0px;
      padding-left: 20px;
      background-image: url('CQMT/assets/BulletIcon.svg');
      background-position: 0 5px;
      background-size: 10px 10px;
      background-repeat: no-repeat;
    }
  }

  dialog {
    opacity: 0;
    transition-property: opacity;
    transition-duration: 0.4s;
    transition-behavior: allow-discrete;

    border: 1px solid var(--bunker-50);
    border-radius: 8px;
    max-width: 50vw;
  }

  dialog[open] {
    opacity: 1;

    @starting-style {
      opacity: 0;
    }
  }

  dialog[open]::backdrop {
    background-color: black;
    opacity: 0.25;
  }

  .cqmt-dialog-container {
    padding: 8px;
  }
  .cqmt-dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 0 16px;
    border-bottom: 1px solid var(--bunker-50);

    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1rem;
    letter-spacing: 1px;
  }
  .close-icon {
    cursor: pointer;
    filter: invert(100%) sepia(0%) saturate(1587%) hue-rotate(345deg) brightness(111%) contrast(101%);
  }
  .cqmt-dialog-body {
    width: 100%;
  }
  .cqmt-dialog-message {
    padding: 8px 16px;

    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 0.1%;
  }
  .cqmt-dialog-video-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cqmt-dialog-video {
    padding: 8px 0;
    max-height: 50vh;
    max-width: 50vw;
  }

  .cqmt-preferences-section {
    margin-top: 16px;
    background-color: var(--bunker-1000);
    border-radius: 6px;
    padding: 16px;
  }

  .cqmt-preferences-header {
    color: white;
    font-family: 'Inter', sans-serif;
    font-weight: 500;
    font-size: 0.75rem;
    line-height: 1rem;
    letter-spacing: 2px;
    margin-bottom: 12px;
    text-transform: uppercase;
  }

  .cqmt-preference-container {
    display: flex;
    align-items: center;
  }

  .cqmt-preference-checkbox {
    cursor: pointer;
    margin-right: 8px;
    accent-color: rgb(87, 162, 132);
  }

  .cqmt-preference-label {
    cursor: pointer;
    color: white;
    font-family: 'Inter', sans-serif;
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .cqmt-button {
    background-color: var(--patina-700);
  }

</style>

<div class="cqmt-home-menu">
  <div class="cqmt-row">
    <div id="gettingStartedButton" class="cqmt-rounded-container cqmt-centered-info button-hover cqmt-button">
      <span class="cqmt-icon-spacing">
        <img src="CQMT/assets/ChevronRightIcon.svg" />
      </span>
      <span class="cqmt-info-header-text">Get Started</span>
    </div>
    <a id="supportLink" class="cqmt-rounded-container cqmt-centered-info cqmt-button" href="mailto:support@costquest.com">
      <span class="cqmt-icon-spacing">
        <img src="CQMT/assets/HelpIcon.svg" />
      </span>
      <span class="cqmt-info-header-text">Support</span>
    </a>
  </div>
  <div class="cqmt-row">
    <div class="cqmt-rounded-container">
      <div class="cqmt-row">
        <span class="cqmt-icon-spacing">
          <img src="CQMT/assets/UserIcon.svg" />
        </span>
        <span class="cqmt-welcome-text">Welcome Back, <span id="userName" class="cqmt-user-text">USER</span></span>
      </div>
      <div class="cqmt-row">
        <div class="cqmt-info-text">
          Start your analysis by defining an Area of Interest (AoI), then dive into statistics and reporting.
        </div>
      </div>
      <div class="cqmt-subscription-info">
        <div class="cqmt-subscription-header">
          <div class="cqmt-header-text">
            SUBSCRIPTION
          </div>
          <div id="userSubscription" class="cqmt-subscription-indentation cqmt-bold-text">
            Testing
          </div>
        </div>
        <div class="cqmt-subscription-body" style="background-color: #0D1420;">
          <div class="cqmt-header-text">
            CURRENT DATA VERSION
          </div>
          <div class="cqmt-subscription-indentation cqmt-bold-text">
            <ul id="dataVersions">
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="cqmt-row">
    <a id="contactUsLink" class="cqmt-rounded-container cqmt-centered-info cqmt-button" href="mailto:sales@costquest.com">
      <span class="cqmt-icon-spacing">
        <img src="CQMT/assets/EmailIcon.svg" />
      </span>
      <span class="cqmt-info-header-text">Contact Us</span>
    </a>
  </div>

  <div class="cqmt-preferences-section">
      <div class="cqmt-preferences-header">Preferences</div>
      <div class="cqmt-preference-container">
        <input type="checkbox" id="openHomeMenuPreference" class="cqmt-preference-checkbox">
        <label for="openHomeMenuPreference" class="cqmt-preference-label">Open home menu at the start of each session</label>
      </div>
    </div>
  </div>

</div>

<dialog id="cqmtWelcomeDialog" class="cqmt-dialog-container">
  <div class="cqmt-dialog-header">
    <p id="cqmtDialogWelcomeText">Welcome</p>
    <button>
      <img id="dialogCloseIcon" src="CQMT/assets/CloseIcon.svg" class="close-icon" />
    </button>
  </div>
  <div class="cqmt-dialog-body">
    <p id="cqmtDialogWelcomeMessage" class="cqmt-dialog-message">Welcome message</p>
    <div class="cqmt-dialog-video-container">
      <video controls id="cqmtDialogVideo" src="" class="cqmt-dialog-video"></video>
    </div>
  </div>
</dialog>
`

type HomeMenuProps = {
  userinfo?: UserInfo | null
  homeLinks?: HomeLinks
  modalConfig?: ModalConfig | null
  sources?: Source[] | null
}

type HomeMenuElement = HTMLElement & HomeMenuProps

export class HomeMenu extends BaseWebComponent implements HomeMenuElement {
  private _userinfo: UserInfo | null
  private _homeLinks: HomeLinks
  private _modalConfig: ModalConfig | null
  private _sources: Source[] | null

  protected get template(): string {
    return template
  }

  constructor() {
    super()

    this.attachShadow({ mode: 'open' })
    this.shadowRoot.innerHTML = template

    this._userinfo = null
    this._sources = null
    this._homeLinks = {
      contactLink: 'mailto:sales@costquest.com',
      supportLink: 'mailto:support@costquest.com',
    }
    this._modalConfig = null
  }

  connectedCallback() {
    const dialog = queryElement(
      this.shadowRoot,
      HTMLDialogElement,
      '#cqmtWelcomeDialog',
    )
    this.shadowRoot
      .querySelector('#gettingStartedButton')
      .addEventListener('click', () => {
        if (this.isEmpty(this.modalConfig)) {
          const openModal = new CustomEvent('cqmt-open-modal', {
            bubbles: true,
            cancelable: true,
            composed: true,
            detail: 'Open Getting Started modal.',
          })
          this.dispatchEvent(openModal)
        } else {
          dialog.showModal()
        }
      })

    this.shadowRoot
      .querySelector('#dialogCloseIcon')
      .addEventListener('click', () => {
        dialog.close()
      })

    const preferenceCheckbox = queryElement(
      this.shadowRoot,
      HTMLInputElement,
      '#openHomeMenuPreference',
    )

    preferenceCheckbox.checked =
      localStorage.getItem('openHomeMenuByDefault') === 'true'

    preferenceCheckbox.addEventListener('change', (event) => {
      const target = event.target as HTMLInputElement
      localStorage.setItem('openHomeMenuByDefault', target.checked.toString())
    })
  }

  static get observedAttributes() {
    return ['userinfo', 'sources', 'homelinks', 'modalconfig']
  }

  get userinfo() {
    return this._userinfo
  }
  set userinfo(newVal) {
    this._userinfo = newVal
    this.updateUserDisplay()
  }

  updateUserDisplay() {
    queryElement(this.shadowRoot, HTMLElement, '#userName').innerText =
      this.userinfo.userName || 'User'
    queryElement(this.shadowRoot, HTMLElement, '#userSubscription').innerText =
      this.userinfo.userSubscription || 'Subscription Level'
  }

  get sources() {
    return this._sources
  }
  set sources(newVal) {
    this._sources = newVal
    this.updateLayerVersionDisplay()
  }

  updateLayerVersionDisplay() {
    if (this.sources && Array.isArray(this.sources)) {
      const dataVersions = this.shadowRoot.querySelector('#dataVersions')

      const sourceNames = this.sources.map((source) => {
        const version = document.createElement('li')
        version.innerText = source.name + ' ' + source.version
        return version
      })
      dataVersions.prepend(...sourceNames)
    }
  }

  get homeLinks() {
    return this._homeLinks
  }
  set homeLinks(newVal) {
    this._homeLinks = newVal
    this.updateLinkDisplay()
  }

  updateLinkDisplay() {
    if (this.homeLinks) {
      if (this.homeLinks.contactLink) {
        queryElement(this.shadowRoot, HTMLAnchorElement, '#dataVersions').href =
          this.homeLinks.contactLink
      }
      if (this.homeLinks.supportLink) {
        queryElement(this.shadowRoot, HTMLAnchorElement, '#supportLink').href =
          this.homeLinks.supportLink
      }
    }
  }

  get modalConfig() {
    return this._modalConfig
  }
  set modalConfig(newVal) {
    this._modalConfig = newVal
    this.updateModalDisplay()
  }

  updateModalDisplay() {
    if (this.modalConfig) {
      if (this.modalConfig.welcomeText) {
        queryElement(
          this.shadowRoot,
          HTMLElement,
          '#cqmtDialogWelcomeText',
        ).innerText = this.modalConfig.welcomeText
      }
      if (this.modalConfig.welcomeMessage) {
        queryElement(
          this.shadowRoot,
          HTMLElement,
          '#cqmtDialogWelcomeMessage',
        ).innerText = this.modalConfig.welcomeMessage
      }

      const dialogVideo = queryElement(
        this.shadowRoot,
        HTMLVideoElement,
        '#cqmtDialogVideo',
      )
      if (this.modalConfig.videoURL) {
        dialogVideo.src = this.modalConfig.videoURL
        dialogVideo.style.display = 'inline'
      } else {
        dialogVideo.style.display = 'none'
      }
    }
  }

  attributeChangedCallback(attrName, oldVal, newVal) {
    if (attrName.toLowerCase() === 'userinfo') {
      this.userinfo = newVal
    }

    if (attrName.toLowerCase() === 'sources') {
      this.sources = newVal
    }

    if (attrName.toLowerCase() === 'homelinks') {
      this.homeLinks = newVal
    }
  }

  isEmpty(obj) {
    return Object.keys(obj).length === 0 && obj.constructor === Object
  }
}

if (!window.customElements.get('cqmt-side-menu-home')) {
  window.customElements.define('cqmt-side-menu-home', HomeMenu)
}
